import { OriButton } from '~/components/ui/button';
import {
    OriDialogComponent,
    OriDialogComponentNoRDX,
    OriDialogDescription,
    OriDialogFooter,
    OriDialogHeader,
    OriDialogTitle,
} from '~/components/ui/dialog';
import { RdxDialogCloseDirective } from '@radix-ng/primitives/dialog';
import { Component, ViewChild, ViewChildren, QueryList, ElementRef, Output, Input, EventEmitter, TemplateRef, WritableSignal, Inject } from '@angular/core';
import { OriTextarea } from '~/components/ui/textarea';
import { Copy, LucideAngularModule} from 'lucide-angular';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { OVERLAY_DATA } from '~/components/overlay.service';
import { OverlayRef } from '@angular/cdk/overlay';


@Component({
  selector: 'preview-dialog',
  standalone: true,
  imports: [
    OriDialogComponent,
    OriDialogDescription,
    OriDialogHeader,
    OriDialogTitle,
    OriDialogFooter,
    OriButton,
    RdxDialogCloseDirective,
    OriTextarea,
    LucideAngularModule,
    ClipboardModule,
    OriDialogComponentNoRDX
  ],
  template: `
      <ori-dialog-content2 (close)="close()" class="flex flex-col gap-0 p-0 sm:max-h-[min(640px,80vh)] sm:max-w-xl [&>button:last-child]:top-3.5" >
        <ori-dialog-header class="contents space-y-0 text-left">
          <ori-dialog-title class="border-border border-b px-6 py-4 text-base">
            CBEM card
          </ori-dialog-title>
          <div class="overflow-y-auto select-none">
            <ori-dialog-description>
              <div class="px-6 py-4">
                <div class="[&_strong]:text-foreground space-y-4 [&_strong]:font-semibold">

                  <div class="space-y-4">
                    @for (data of rowData; track data;){
                      <div class="space-y-1">

                        @if (data.cellType === 'text') {
                          <p class="flex flex-row">
                            <strong>{{data.header}} </strong>
                            <button [cdkCopyToClipboard]="data.cellValue" class="ml-auto">
                            <lucide-angular class="transition active:scale-95 cursor-pointer" [img]="Copy" size="16" strokeWidth="2"/>
                            </button>
                        </p>
                          <p>
                            <textarea #autoResize (input)="handleInput($event)"  [rows]="defaultRows" class="min-h-[none] focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-1 resize-none" oriTextarea>{{data.cellValue}}</textarea>

                          </p>
                        } 
                          
                      </div>
                    }
                  </div>
                </div>
              </div>
            </ori-dialog-description>
          </div>
        </ori-dialog-header>
        <ori-dialog-footer class="border-border border-t px-6 py-4 sm:items-center">
          <button oriButton type="button" variant="outline" (click)="close()" >Close</button>
          <button  oriButton disabled type="button" >Update</button>
        </ori-dialog-footer>
      </ori-dialog-content2>
  `,
   
})
export class PreviewDialogComponent {
  @ViewChild('contentRef') contentRef!: ElementRef;
  @ViewChild('dialog', {static: true}) public dialogTemplate!: TemplateRef<void>; // Changed from TemplateRef<unknown> to TemplateRef<void>
  @ViewChildren('autoResize') textareas!: QueryList<ElementRef<HTMLTextAreaElement>>;
  protected readonly Copy = Copy;
  hasReadToBottom = false;

  constructor(@Inject(OVERLAY_DATA) public rowData: any, private overlayRef: OverlayRef) {
  }

  defaultRows = 1;
  maxRows = undefined;



  ngAfterViewInit() {

      this.textareas.changes.subscribe(() => {
        this.resizeAllTextareas();
      });
    }

  private resizeAllTextareas(): void {
    this.textareas?.forEach(textareaRef => {
      const textareaElement = textareaRef.nativeElement;
      textareaElement.style.height = 'auto';

      const style = window.getComputedStyle(textareaElement);
      const borderHeight = parseInt(style.borderTopWidth) + parseInt(style.borderBottomWidth);
      const paddingHeight = parseInt(style.paddingTop) + parseInt(style.paddingBottom);

      const lineHeight = parseInt(style.lineHeight);
      const maxHeight = this.maxRows ? lineHeight * this.maxRows + borderHeight + paddingHeight : Infinity;

      const newHeight = Math.min(textareaElement.scrollHeight + borderHeight, maxHeight);

      textareaElement.style.height = `${newHeight}px`;

    });
  }

  handleInput($event: Event) {
    this.resizeAllTextareas();
  }

  close() {
    if (this.overlayRef) {
      this.overlayRef.dispose();
    }
  }

  handleScroll() {
    const content = this.contentRef?.nativeElement as HTMLElement;
    if (!content) return;
    const scrollPercentage = content.scrollTop / (content.scrollHeight - content.clientHeight);
    if (scrollPercentage >= 0.99 && !this.hasReadToBottom) {
      this.hasReadToBottom = true;
    }
  }
}
